
<template>
  <div class="modals-widget">
    <!-- Feed modals -->
    <div class="feed-modal" v-if="feed_modal && modal_type === 'feed'">
      <div class="overlay" @click.self="feed_modal = false">
        <div class="container-widget">
          <span class="title">
            Welcome to
            <strong>Your Feed</strong>
          </span>
          <p>Post, View and Share your thoughts worldwide…</p>
          <p v-if="false">Enjoy the World of Consultants</p>
          <button class="post-btn" @click="postSomething()">
            Post Something…
          </button>
          <button class="cancel-btn" @click="feed_modal = false">Later</button>
        </div>
      </div>
    </div>
    <!-- End Feed modals -->
    <!-- Profile modals -->
    <div class="profile-modal" v-if="profile_modal && modal_type === 'profile'">
      <div class="overlay" @click.self="profile_modal = false">
        <div class="container-widget">
          <span class="title">
            Welcome to
            <strong>your Profile</strong>
          </span>
          <p v-if="false">Create and Share your Resume Professionally</p>
          <button class="post-btn" @click="completeProfile()">
            Complete Your Profile
          </button>
          <button class="cancel-btn" @click="profile_modal = false">
            Later
          </button>
        </div>
      </div>
    </div>
    <!-- End Profile modals -->
  </div>
</template>

<script>
export default {
  data: () => ({
    feed_modal: false,
    profile_modal: false,
    modal_type: "",
  }),
  props: ["type"],
  computed: {},
  mounted() {
    let vm = this;
    vm.modal_type = vm.type;
    if (vm.modal_type == "feed") {
      if (sessionStorage.new_user_feed_modal) {
        vm.feed_modal = true;
        sessionStorage.removeItem("new_user_feed_modal");
      }
    }
    if (vm.modal_type == "profile") {
      if (sessionStorage.new_user_profile_modal) {
        vm.profile_modal = true;
        sessionStorage.removeItem("new_user_profile_modal");
      }
    }
  },
  watch: {},
  methods: {
    completeProfile() {
      let vm = this;
      vm.profile_modal = false;
      vm.$emit("completeProfile", null);
    },
    postSomething() {
      let vm = this;
      vm.feed_modal = false;
      document.querySelector("#new-post-textarea").focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.modals-widget {
  .feed-modal,
  .profile-modal {
    .overlay {
      position: fixed;
      left: 0px;
      right: 0px;
      top: 0px;
      bottom: 0px;
      background: rgba($color: #000000, $alpha: 0.7);
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      .container-widget {
        background: transparent
          linear-gradient(130deg, #1ba5a4 0%, #1ba5a4 0%, #1885ad 100%) 0% 0%
          no-repeat padding-box;
        border: 1px solid #707070;
        border-radius: 5px;
        width: 702px;
        height: 291px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .title {
          color: #fff;
          font-weight: 200;
          font-size: 25px !important;
          margin-bottom: 20px;
          strong {
            font-weight: 800;
          }
        }
        p {
          color: #efefef;
          margin-bottom: 20px;
        }
        button {
          width: 302px;

          border-radius: 18px;
          outline: none;
          border: none;
          margin-bottom: 20px;
        }
        .post-btn {
          background: #ffffff 0% 0% no-repeat padding-box;
          color: #0884af;
          height: 36px;
        }
        .cancel-btn {
          background: transparent;
          color: #fff;
        }
      }
    }
  }
}
</style>